var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 40.2813C77.3438 55.4063 64.7812 67.5 49.6562 67.5H22.8125C11.8125 67.5 2.5 58.5 2.5 47.5C2.50137 43.034 3.99747 38.697 6.7499 35.18C9.50233 31.663 13.3527 29.1684 17.6875 28.0938C17.9053 28.0423 18.1329 28.0503 18.3466 28.1168C18.5603 28.1834 18.7522 28.3061 18.9022 28.4721C19.0523 28.6381 19.155 28.8414 19.1997 29.0607C19.2444 29.28 19.2294 29.5072 19.1562 29.7188C18.0603 33.0035 17.501 36.4435 17.5 39.9063C17.4897 40.555 17.7259 41.1835 18.1609 41.6648C18.5959 42.1462 19.1973 42.4447 19.8438 42.5C20.185 42.5214 20.5269 42.4725 20.8485 42.3565C21.1701 42.2405 21.4645 42.0597 21.7134 41.8254C21.9624 41.5911 22.1606 41.3082 22.2959 40.9942C22.4312 40.6803 22.5007 40.3419 22.5 40C22.4861 35.7343 23.482 31.5258 25.4063 27.7188C28.1873 22.1586 32.7704 17.7048 38.4078 15.0839C44.0453 12.463 50.4044 11.8296 56.4481 13.287C62.4918 14.7444 67.8633 18.2067 71.6865 23.1091C75.5096 28.0115 77.5589 34.0646 77.5 40.2813Z",
    fill: "#F3F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.2be9bc2cf6320c2106912f771820d3f5.svg";
export { ForwardRef as ReactComponent };